module.exports = __webpack_public_path__ + "c1052f541101c88b6ac02360349b11a0.png";